import { render, staticRenderFns } from "./NewsSearch.vue?vue&type=template&id=2f9ed186&scoped=true&"
import script from "./NewsSearch.vue?vue&type=script&lang=js&"
export * from "./NewsSearch.vue?vue&type=script&lang=js&"
import style0 from "./NewsSearch.vue?vue&type=style&index=0&id=2f9ed186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ed186",
  null
  
)

export default component.exports